import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  display: block;\n  &:focus {\n    ",
        "\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Box, Link, Text, Image } from "@miro-site/core";
import styled, { css, useTheme } from "styled-components";
import { useTranslation } from "next-i18next";
var Container = styled(Box).attrs(function(param) {
    var miroverseHighlighted = param.theme.miroverseHighlighted;
    return {
        $py: miroverseHighlighted.container.verticalPadding,
        $px: miroverseHighlighted.container.horizontalPadding,
        $styles: {
            borderRadius: miroverseHighlighted.container.radius,
            backgroundColor: miroverseHighlighted.container.background
        }
    };
}).withConfig({
    componentId: "sc-5e264b3f-0"
})(_templateObject());
var MiroverseTitle = styled(Text).attrs(function(param) {
    var miroverseHighlighted = param.theme.miroverseHighlighted;
    return {
        as: miroverseHighlighted.title.as,
        $variant: miroverseHighlighted.title.variant,
        $styles: {
            fontWeight: miroverseHighlighted.title.fontWeight,
            color: miroverseHighlighted.title.color
        }
    };
})({});
var ItemContainer = styled(Box).attrs(function(param) {
    var miroverseHighlighted = param.theme.miroverseHighlighted;
    return {
        $styles: {
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            paddingBottom: miroverseHighlighted.itemContainer.verticalPadding,
            paddingTop: miroverseHighlighted.itemContainer.verticalPadding
        }
    };
}).withConfig({
    componentId: "sc-5e264b3f-1"
})(_templateObject1());
export var ItemLink = styled(Link).withConfig({
    componentId: "sc-5e264b3f-2"
})(_templateObject2(), function(props) {
    return props.theme.normalizeStyles(props.theme.focus.outlines.withOffset);
});
var HeroBannerLink = styled(ItemLink).withConfig({
    componentId: "sc-5e264b3f-3"
})(_templateObject4(), function(param) {
    var miroverseHighlighted = param.theme.miroverseHighlighted, _lineBottom = param.lineBottom, lineBottom = _lineBottom === void 0 ? false : _lineBottom;
    return lineBottom && css(_templateObject3(), miroverseHighlighted.itemContainer.link.dividerColor);
});
var ActionLink = styled(Link).attrs(function(param) {
    var miroverseHighlighted = param.theme.miroverseHighlighted;
    return {
        $variant: miroverseHighlighted.actionLink.variant,
        $color: miroverseHighlighted.actionLink.color,
        $size: miroverseHighlighted.actionLink.size,
        withArrow: miroverseHighlighted.actionLink.withArrow
    };
}).withConfig({
    componentId: "sc-5e264b3f-4"
})(_templateObject5(), function(param) {
    var _theme = param.theme, normalizeStyles = _theme.normalizeStyles, miroverseHighlighted = _theme.miroverseHighlighted;
    return normalizeStyles({
        fontSize: miroverseHighlighted.actionLink.fontSize,
        fontWeight: miroverseHighlighted.actionLink.fontWeight
    });
});
export var ItemDescription = styled(Text).attrs(function(param) {
    var miroverseHighlighted = param.theme.miroverseHighlighted;
    return {
        $styles: {
            fontSize: miroverseHighlighted.itemContainer.itemDescription.fontSize,
            lineHeight: miroverseHighlighted.itemContainer.itemDescription.lineHeight,
            color: miroverseHighlighted.itemContainer.itemDescription.color
        }
    };
}).withConfig({
    componentId: "sc-5e264b3f-5"
})(_templateObject6());
export var CategoryHeroBanner = function() {
    var miroverseHighlighted = useTheme().miroverseHighlighted;
    var t = useTranslation("common").t;
    return /*#__PURE__*/ _jsxs(Container, {
        "data-track-place": "Hero Category Banner",
        children: [
            /*#__PURE__*/ _jsxs(MiroverseTitle, {
                children: [
                    t("miroverse-section-in-category-menu-initial"),
                    " ",
                    /*#__PURE__*/ _jsx("br", {}),
                    t("miroverse-section-in-category-menu-end")
                ]
            }),
            /*#__PURE__*/ _jsx(HeroBannerLink, {
                target: "_blank",
                href: "/miroverse/",
                children: /*#__PURE__*/ _jsx(ItemContainer, {
                    children: /*#__PURE__*/ _jsx(Box, {
                        $styles: {
                            width: miroverseHighlighted.itemContainer.imageWidth
                        },
                        children: /*#__PURE__*/ _jsx(Image, {
                            name: "miroverse-profiles",
                            "aria-hidden": true,
                            src: "https://images.ctfassets.net/qop92tnevinq/6YEjAd5p8dQnQAFqjx3HAV/d6cc387f649b467cf7c37c5c230c143e/miroverse_banner_faces_small.png"
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(ActionLink, {
                target: "_blank",
                href: "/miroverse/",
                children: t("miroverse-cta-category-menu")
            })
        ]
    });
};
